import {clsx} from 'clsx'
import {Tooltip} from '@primer/react/deprecated'
import {AlertIcon, CheckIcon, XIcon} from '@primer/octicons-react'
import {GitHubAvatar} from '@github-ui/github-avatar'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'

import styles from './ListItem.module.css'

type ListItemProps = {
  state: string
  avatarLabel?: string
  avatarUrl?: string
  hovercardUrl?: string
  title: string
  description?: string
  warning?: string
  titleClass?: string
  paddingY?: number
  paddingLeft?: number
}
export function ListItem({
  state,
  avatarLabel,
  avatarUrl,
  hovercardUrl,
  title,
  description,
  warning,
  titleClass,
  paddingY,
  paddingLeft,
}: ListItemProps) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()
  const Icon = state === 'success' ? CheckIcon : XIcon
  return (
    <li
      style={{
        paddingBlock: `${(paddingY ?? 2) * 4}px`,
        paddingLeft: `${(paddingLeft ?? 2) * 4}px`,
      }}
      className={styles.ListItemContainer}
    >
      <Icon size={16} className={state === 'success' ? styles.iconSuccess : styles.iconFailure} />
      {avatarUrl && (
        <GitHubAvatar
          aria-label={avatarLabel}
          src={avatarUrl}
          {...(hovercardUrl ? getHovercardAttributesForType('user', {url: hovercardUrl}) : {})}
        />
      )}
      <span className={clsx(titleClass, !titleClass && styles.titleBold)}>{title}</span>
      {description ? <span className={styles.ListItemText}>{description}</span> : null}
      {warning && (
        <Tooltip aria-label={warning} wrap>
          <AlertIcon size={16} />
        </Tooltip>
      )}
    </li>
  )
}
